<h5>Documenti obbligatori</h5>
@if (accept !== '*') {
  <small class="d-block mb-3">Sono accettati file in formato pdf, p7m e zip</small>
}
<div class="d-flex flex-wrap">
  @for (group of mandatoryFormArray.controls; track group; let i = $index) {
    <div class="me-3" [formGroup]="$any(group)">
      <label class="text-secondary">{{ getDocumentTypeDescription(i) }}</label>
      <ellf-file-reader
        [accept]="accept"
        formControlName="attachment"
        [multiple]="false"
        [readOnly]="readOnly"
      ></ellf-file-reader>
      <div class="my-2"></div>
      <div class="my-2">
        @if (
          group.get('createdDate')?.value &&
          (group.get('attachment')?.value || []).length
        ) {
          <span>Creato il {{ group.get('createdDate')?.value || '' }}</span>
        }
      </div>
      <ellf-text-input
        placeholder="Note"
        formControlName="notes"
        [longText]="true"
        [readOnly]="readOnly || !(group.get('attachment')?.value || []).length"
      >
      </ellf-text-input>
      <!-- @if (
        btnSync &&
        (group.get('attachment')?.value || []).length > 0 &&
        group.get('synchWithCoswin')?.value === null &&
        group.get('toSync')?.value === true
      ) {
        <button
          class="btn col-md-12 btn-warning mt-2"
          type="button"
          (click)="synchDocument(group.get('id')?.value)"
        >
          Non sincronizzato
          <i class="feather icon-upload icon-btn"></i>
        </button>
      } -->
    </div>
  }
</div>
@if (mandatoryFormArray.controls.length === 0) {
  <div>Non ci sono documenti obbligatori</div>
}
<!-- Documenti facoltativi -->
<h5 class="mt-3">Documenti aggiuntivi</h5>
@if (accept !== '*') {
  <small class="d-block mb-3">Sono accettati file in formato pdf, p7m e zip</small>
}
@if (!isDisabled && !readOnly) {
  <button class="btn btn-primary mb-2" type="button" (click)="addDocument()">
    Nuovo documento aggiuntivo
  </button>
}
<div class="d-flex flex-wrap">
  @for (group of additionalFormArray.controls; track group; let i = $index) {
    <div class="me-3" [formGroup]="$any(group)">
      <div class="d-flex align-items-center">
        <label class="text-secondary">Tipo documento</label>
        @if (!isDisabled && !readOnly) {
          <i
            class="icon-btn feather icon-x ms-auto text-danger"
            (click)="removeAt(i)"
            title="elimina"
          >
          </i>
        }
      </div>
      <ellf-select
        class="mb-2"
        [items]="documentTypes"
        formControlName="documentType"
        [clearable]="false"
        [readOnly]="readOnly"
      ></ellf-select>
      <ellf-file-reader
        class="mb-2"
        formControlName="attachment"
        [accept]="accept"
        [multiple]="false"
        [readOnly]="readOnly"
      ></ellf-file-reader>
      <div class="my-2"></div>
      <!-- <div class="my-2">
        @if (group.get('createdDate')?.value && (group.get('attachment')?.value || []).length) {
          <span>Creato il {{ group.get('createdDate')?.value || '' }}</span>
        }
      </div> -->
      <ellf-text-input
        placeholder="Note"
        formControlName="notes"
        [longText]="true"
        [readOnly]="readOnly || !(group.get('attachment')?.value || []).length"
      >
      </ellf-text-input>
      @if (
        btnSync &&
        (group.get('attachment')?.value || []).length > 0 &&
        group.get('synchWithCoswin')?.value === null &&
        group.get('toSync')?.value === true
      ) {
        <button
          class="btn col-md-12 btn-warning mt-2"
          type="button"
          (click)="synchDocument(group.get('id')?.value)"
        >
          Non sincronizzato
          <i class="feather icon-upload icon-btn"></i>
        </button>
      }
    </div>
  }
</div>
